import { useEffect, useState } from "react";
import { onAddGoals, onGetEmployeeGoals, onGetOrgGoals, onGetTemplateGoals } from "../services/goals";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import useNotificationHook from "./useNotificationHook";
import useEmployeeHook from "./useEmployeeHook";

export default () => {
  interface GoalItemDTO {
    title: string;
    desc: string;
    target: string;
    date: string;
    deptID?: number;
    progress: string;
    positionID: number;
    employeeID?: number;
    templateID: number;
    organizationID: number;
}
  const { config } = useStateGetter();
  const { SelectedOrg } = useStateGetter();
  const [allorgoals, setallorgoals] = useState([]);
    const { AddNotification } = useNotificationHook();
    const { selectedOrgEmployees } = useEmployeeHook();
  
  const AddGoal = async (postdata: GoalItemDTO) => {
    try {
      var res = await onAddGoals(postdata, config);
      toast(res.message);
      //send notifcation to affected users
      {
        postdata.target == "organization" &&
          AddNotification({
            users: selectedOrgEmployees,
            message: `You have a new goal: ${postdata.title} assigned to you`
          });
      }
      {
        postdata.target == "employee" &&
          AddNotification({
            users: selectedOrgEmployees.filter(
              (k: any, key: number) => k.employeeID == postdata.employeeID
            ),
            message: `You have a new goal: ${postdata.title} assigned to you`
          });
      }

      {
        postdata.target == "position" &&
          AddNotification({
            users: selectedOrgEmployees.filter(
              (k: any, key: number) => k.positionID == postdata.positionID
            ),
            message: `You have a new goal: ${postdata.title} assigned to you`
          });
      }
      {
        postdata.target == "dept" &&
          AddNotification({
            users: selectedOrgEmployees.filter(
              (k: any, key: number) => k.deptID == postdata.deptID
            ),
            message: `You have a new goal: ${postdata.title} assigned to you`
          });
      }
    } catch (e: any) {
      console.log(e);
    }
  };
  const getOrgGoals = async () => {
    var res = await onGetOrgGoals(SelectedOrg.id, config);
    setallorgoals(res.data);
  };
  const getTemplategoals = async (tempID:number) => {
    var res = await onGetTemplateGoals(tempID, config);
    return(res.data);
  };
  const getEmployeegoals = async (tempID:number) => {
    var res = await onGetEmployeeGoals(tempID, config);
    return(res.data);
  };

  useEffect(() => {
    getOrgGoals();
  }, []);

  return { AddGoal, allorgoals, getOrgGoals, getEmployeegoals ,getTemplategoals};
};
